<!-- Divider -->
<div class="{{ classMarginSeparator }} border-t" *ngIf="showBar"></div>

<!-- Section -->
<div class="w-full">
    <div class="text-xl">{{ title }}</div>
    <div *ngIf="subtitle" class="text-secondary">{{ subtitle }}</div>
</div>
